export const filterBannersList = (banners, authenticated) =>
  banners.filter(
    banner =>
      banner.user_visibility === 'public' ||
      (banner.user_visibility === 'registered' && authenticated) ||
      (banner.user_visibility === 'anonymous' && !authenticated),
  );
